import { put, call, take, fork } from 'redux-saga/effects'
import { createCourseService } from '../../api/course'
import { createCourseSuccess } from '../../reducers/course/action'
import { CREATE_COURSE } from '../../reducers/course/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* courseCreateFlow(payload) {
  try {
    const { data, callback } = payload

    const response = yield call(createCourseService, data)

    yield put(createCourseSuccess(response.data))
    yield put(operationSuccess())

    callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* createCourseWatcher() {
  while (true) {
    const action = yield take(CREATE_COURSE)
    const { payload } = action

    yield fork(generalSaga, courseCreateFlow, payload)
  }
}
